import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../../apiSlice";

/* ---------- Adapter ---------- */
const sellerAdapter = createEntityAdapter({
  selectId: (seller) => seller.id,
});

const initialState = sellerAdapter.getInitialState();

/* ---------- API ---------- */
export const inventorySellerListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInventorySpareSellerList: builder.query({
      query: () => "inventory/spares/sellers",
      transformResponse: (response) => {
        const sellers = response.data || [];

        return sellerAdapter.setAll(initialState, [
          { id: "", label: "Select Seller" }, // 👈 default option
          ...sellers,
        ]);
      },
    }),
  }),
});

export const { useGetInventorySpareSellerListQuery } = inventorySellerListSlice;

/* ---------- Stable selectors ---------- */
const selectSellerQueryResult =
  inventorySellerListSlice.endpoints.getInventorySpareSellerList.select();

/**
 * 🔑 IMPORTANT:
 * This selector is memoized
 */
const selectSellerData = createSelector(
  selectSellerQueryResult,
  (result) => result?.data ?? initialState
);

/* ---------- Export adapter selectors ---------- */
export const {
  selectAll: selectAllSellers,
  selectById: selectSellerById,
  selectIds: selectSellerIds,
} = sellerAdapter.getSelectors((state) => selectSellerData(state));
